import React from "react";
import MuiTextField from "@mui/material/TextField";
import { textFieldProps } from "./fieldProps";

/** `date` — the native date input (keyboard-operable everywhere); submitted as `YYYY-MM-DD`. */
export default function DateField(props) {
	return <MuiTextField {...textFieldProps(props)} type="date" InputLabelProps={{ shrink: true }} />;
}
